import { useEffect } from 'react';
import './App.css';
import { Game } from './Game/Game.js';


/**
 * TODO: What if we make this multiplayer so Binca & I can play together?
 */
function App() {

  useEffect(()=>{
  
    const tinyWidth = document.getElementById('tiny-tag').style.width
    document.getElementById('header').style.left += tinyWidth
  },[]);

  return (
    <div id='app' className="App">
      <div id="header" style={{display:'flex', flexDirection:'row', justifyContent:'flex-end', width:'fit-content', transform:'translateX(calc( 50% - 75px )', fontSize:'12px'}}><h1>BINCA BLOCK</h1><span style={{transform:'translateX( -50% )'}}><span style={{display:'flex', flexDirection:"row"}} id="tiny-tag">tiny &nbsp; <span style={{display:'flex', flexDirection:"column", transform:'translateY(-40px)'}}><img style={{ transform:'translateX(-10px) translateY(5px)'}}src='/partyhat.png' width={40} height={40}/>BIRTHDAY &nbsp; </span>edition</span></span></div>
      <Game></Game>
    </div>
  );
}

export default App;
